<div class="block">
    <div class="flex flex-row justify-between items-center">
        <div>{{ displayValue() }}</div>
        @if (shouldBeVisibleToggleButton()) {
            <button class="document-toggle"
                    (click)="toggleIsDocumentVisible($event)">
                {{ buttonText() }}
            </button>
        }
    </div>
</div>
